import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI3S_DEMO_3 = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: `When someone attempts to input a harmful \nprompt into the Globe Connect Assistant \nchatbox,<span style="color: #BEE3FF;"> AI3S immediately recognizes the\n threat and issues a warning to the user</span>,\n advising against proceeding. Simultaneously,\n a nudge is sent to Danu, alerting him to the \nsecurity incident and enabling swift action.`,
  subtitle: "Infosys AI3S DEMO",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(309),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(307),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "RESPONSIBLE_AI/AI3S_d1_06.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "RESPONSIBLE_AI/AI3S_demo_3_computer.png",
          imageStyle: {
            position: "absolute",
            right: "65px",
            bottom: "68px",
          },
          effect: "animate-opacity",
        },
        {
          image: "RESPONSIBLE_AI/AI3S_demo_3_person.png",
          imageStyle: {
            position: "absolute",
            right: "152px",
            bottom: "0px",
          },
          effect: "animate-opacity",
        },
        {
          image: "RESPONSIBLE_AI/AI3S_demo_3_alert_message.png",
          imageStyle: {
            position: "absolute",
            right: "511px",
            bottom: "176px",
          },
        },
        {
          image: "RESPONSIBLE_AI/AI3S_demo_3_close_icon.png",
          imageStyle: {
            position: "absolute",
            right: "41px",
            bottom: "349px",
          },
        },
        {
          image: "RESPONSIBLE_AI/AI3S_demo_3_bubble.png",
          imageStyle: {
            position: "absolute",
            right: "330px",
            bottom: "609.11px",
          },
        },
      ]}
      pageNumber={308}
    />
  ),
};
